import request from '@/plugin/axios'


export function getUser(params) {
  return request({
    url: '/api/purchase/getUser',
    method: 'get',
    params
  })
}
export function newUpload(data) {
  return request({
    url: `/api/_admin/newUpload/${data.path}`,

    method: 'post',
    data: data.file,
    params: data
  })
}
export function savePurchase(data) {
  return request({
    url: '/api/purchase/savePurchase',
    method: 'post',
    data,
  })
}
export function updatePurchase(data) {
  return request({
    url: '/api/purchase/updatePurchase',
    method: 'post',
    data,
  })
}
export function getPurchaseRequisition(params) {
  return request({
    url: '/api/purchase/getPurchaseRequisition',
    method: 'get',
    params,
  })
}
export function setPurchaseRequisitionDetail(data) {
  return request({
    url: '/api/purchase/setPurchaseRequisitionDetail',
    method: 'post',
    data,
  })
}
